import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, ConfigModule, CmsConfig, AuthGuard } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, AppRoutingModule } from '@spartacus/storefront';
import { KbCountryFlagComponent } from '../kb-country-flag.component';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';
import { CookieService } from 'src/app/customServices/cookie.service';



@NgModule({
  declarations: [],
  providers: [
    CountrySelectorService,
    CookieService
  ],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterModule,
    AppRoutingModule,

    ConfigModule.withConfig({
      cmsComponents: {
        CountryFlagComponent: {
          component: KbCountryFlagComponent,
        }
      }
    } as CmsConfig)
  ],
})
export class KbCountryFlagModule { }
